import React, { useEffect, useRef, useState } from "react"
import classnames from "classnames"
import SideBar from "../sidebar"
import { Header } from "./Header"
import { MobileMenu } from "../MobileMenu"
import Nav, { getCurrentRouteIndex } from "../nav"
import { Footer } from "../nav/Footer"
import Transition from "./Transition"
import Cart from "../cart"
import ContactForm from "../contact-form"
import { useAppSelector } from "../../state/hooks"
import "../../styles/global.css"
import "./styles.scss"
import ImagePreviewer from "../previewer"

const Layout = ({ children, location }) => {
  const [isCartDOMOpen, setIsCartDOMOpen] = useState(false)
  const currentRouteIndex = getCurrentRouteIndex(location)
  const isCartOpen = useAppSelector(state => state.menus.isCartOpen)
  const isContactOpen = useAppSelector(state => state.menus.isContactOpen)
  const isPreivewOpen = useAppSelector(state => state.product.productPreviewSrc)

  const shouldShowFade =
    currentRouteIndex > -1 && !location.pathname.match(/^\/objects\/.+/)

  const lastScrollPositionRef = useRef(0)

  useEffect(() => {
    let cartTimeout

    if (isCartOpen) {
      if (window.innerWidth < 768) {
        lastScrollPositionRef.current = window.pageYOffset
      }

      cartTimeout = setTimeout(() => {
        setIsCartDOMOpen(true)
      }, 50)
    } else {
      setIsCartDOMOpen(false)

      cartTimeout = setTimeout(() => {
        window.scrollTo({ top: lastScrollPositionRef.current })
      }, 50)
    }

    return () => {
      clearTimeout(cartTimeout)
    }
  }, [isCartOpen])

  return (
    <>
      <Header />
      <MobileMenu />
      <Cart />
      <ImagePreviewer />
      <ContactForm />

      <main
        className={classnames("w-full min-h-full top-0 md:flex", {
          fixed: isCartDOMOpen || isPreivewOpen || isContactOpen,
        })}
        style={{
          transform:
            isCartDOMOpen || isPreivewOpen || isContactOpen
              ? `translate3d(0, -${lastScrollPositionRef.current}px, 0)`
              : null,
        }}
      >
        <SideBar />

        <div className="flex-1 min-h-screen right-panel">
          <Nav location={location} />

          <Transition location={location}>
            {shouldShowFade && (
              <div className="fixed z-20 w-full pointer-events-none gradient top-14 md:top-24 lg:top-14 fade-to-black h-36"></div>
            )}

            <div
              className={`main-content-container w-full h-full md:px-10 nav-item-${currentRouteIndex}`}
            >
              <div className="flex flex-col h-full max-w-screen-lg mx-auto">
                <div className="flex-grow">{children}</div>
              </div>
            </div>

            <Footer currentRouteIndex={currentRouteIndex} />
          </Transition>
        </div>
      </main>
    </>
  )
}

export default Layout
